var _path, _path2, _circle, _circle2, _circle3, _circle4, _ellipse, _path3, _path4, _circle5, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSantaBody(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 48,
    viewBox: "0 0 31 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 35C15.7 35 9.66669 36 7.50003 36.5C5.79682 38.2032 3.23773 41.237 0.865112 45H30C27.4221 40.4356 24.6153 36.8509 22.5 35Z",
    fill: "#FF5763",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0281 36C15.0474 36 9.74106 36.9 7.83546 37.35C6.33748 38.8829 4.08673 41.6133 2 45H29C26.7327 40.8921 22.8885 37.6658 21.0281 36Z",
    fill: "#FF5763",
    stroke: "#FF5763",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 34,
    r: 9.5,
    fill: "#FFE2DF",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 40,
    r: 7.5,
    fill: "white",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3433,
    cy: 31.3106,
    r: 0.5,
    transform: "rotate(-15 12.3433 31.3106)",
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6124,
    cy: 31.3106,
    r: 0.5,
    transform: "rotate(-15 17.6124 31.3106)",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 31.5,
    rx: 1,
    ry: 0.5,
    fill: "#C58890"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 34L15.183 35.049L16.2321 33.866",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66956 24L14.5 3.80278L20.3304 24H8.66956Z",
    fill: "#F9525C",
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 3.5,
    r: 3,
    fill: "white",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4978 27.8878C22.9681 28.3837 22.4513 28.5278 21.9282 28.4958C21.3203 28.4586 20.6569 28.1806 19.908 27.7726C19.5915 27.6001 19.2725 27.4119 18.9429 27.2174C18.8868 27.1843 18.8305 27.151 18.7737 27.1176C18.3875 26.8902 17.9878 26.6581 17.5831 26.4512C16.7802 26.0407 15.9071 25.7018 15 25.7018C14.0929 25.7018 13.2198 26.0407 12.4169 26.4512C12.0122 26.6581 11.6125 26.8902 11.2263 27.1176C11.1695 27.151 11.1132 27.1843 11.0571 27.2174C10.7275 27.4119 10.4085 27.6001 10.092 27.7726C9.3431 28.1806 8.67968 28.4586 8.07179 28.4958C7.54868 28.5278 7.03185 28.3837 6.50222 27.8878C6.55318 25.5407 7.48016 23.99 8.91942 22.9998C10.4304 21.9604 12.5641 21.5 15 21.5C17.4359 21.5 19.5696 21.9604 21.0806 22.9998C22.5198 23.99 23.4468 25.5408 23.4978 27.8878Z",
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantaBody);
export default __webpack_public_path__ + "static/media/santa-body.8ead10f4f4ec36637939eba9b5d84694.svg";
export { ForwardRef as ReactComponent };